import React, {FC, useState} from "react";
import {Button, InputItem, List, Switch, Toast, WhiteSpace} from "antd-mobile";
import {MyIcon} from "@components/AppIcon";
import {SendCheckCode} from "@components/SendCheckCode";
import {useNavigate} from "react-router-dom";
import {useMount} from "ahooks";
import {getAppUserInfo, isUsedConfidentialPay } from "@api/user";
import { getCheckImg } from "@api/app";
import "./un.scss";

const CheckPhone: FC =()=> {
  const navigate = useNavigate();
  const [mobile, setMobile] = useState('');
  const [code, setCode] = useState<string> ('');
  const [status, changeStatus] = useState(false);

  const [code_image_src, setImgNumData] = useState('');
  const [num_img_uuid, setUuid] = useState('');
  const [code_image, setCodeImage] = useState('');
  useMount(()=> {
    getUserMobile();
    getImgCodedata();
  })

  const getUserMobile = async ()=> {
    try {
      const res = await getAppUserInfo();
      if (res.code === 200) {
        setMobile(res.data.mobile);
        if (res.data.is_balance_confidential_payment) changeStatus(true);
      }
    } catch (e) {
      console.log(e)
    }
  }

  // const changeMobile = (evt: any) => {
  //   setMobile(evt)
  // }
  const changeCode = (evt: any) => {
    setCode(evt)
  }
  
  const getImgCodedata = async()=> {
    const res = await getCheckImg() 
    if (res.code === 200) {
      const { uuid,img } = res.data;
      setUuid(uuid);
      setImgNumData(img);
    }
  }

  const makeSetting = async()=> {
    try {
      if (!code) return Toast.info('请输入验证码');
      const res = await isUsedConfidentialPay({
        mobile,
        verification_code: code,
        is_balance_confidential_payment: status ? 1:0
      })
      Toast.info(res.msg);
      if (res.code === 200) setTimeout(()=> navigate(-1), 800);
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <List className='check-phone' renderHeader={'免密支付配置'}>
      <div className="main-img-code">
        <InputItem onChange={setCodeImage} maxLength={8} placeholder='图片验证'>
          <MyIcon type='iconAPImiyue'/>
        </InputItem>
        <div className="code-image" onClick={getImgCodedata}>
          <img src={code_image_src} alt="图片" />
        </div>
      </div>
      <div className="main-img-code">
        <InputItem onChange={changeCode} maxLength={8} placeholder='请输入验证码'>
          <MyIcon type='iconAPImiyue'/>
        </InputItem>
        <SendCheckCode phone={mobile} code={code_image} uuid={num_img_uuid} />
      </div>

      <WhiteSpace />
      <List.Item extra={
        <Switch
          style={{marginRight: '30px'}}
          checked={status}
          onChange={(val)=> changeStatus(val)}
        />}>
        <span>是否使用免密支付</span>
      </List.Item>
      <WhiteSpace />
      <WhiteSpace />

      <div className={'make-btn'}>
        <Button type="primary" onClick={()=> makeSetting()}>确定</Button><WhiteSpace />
      </div>
      <WhiteSpace />

    </List>
  )
}

export default CheckPhone;